// @flow

import React, { PureComponent } from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import type { Resolution } from 'types/Settings';
import { CropWrap, CropTitle } from './ImageCrop.styled';

type ImageCropType = {
  aspect: number,
};

type Props = {
  imageSrc: string,
  onChange: (imageSrc: string) => void,
  resolution: Resolution,
};
type State = {
  hasValidCrop: boolean,
  crop: ImageCropType,
  image: any,
};

class ImageCrop extends PureComponent<Props, State> {
  state = {
    crop: null,
    hasValidCrop: false,
  };

  constructor(props) {
    super(props);

    const { resolution } = props;
    this.state = { crop: { aspect: resolution.width / resolution.height } };
  }

  componentDidMount() {
    document.addEventListener('keyup', this.handleEnterKeyUp);
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleEnterKeyUp);
  }

  handleEnterKeyUp = ({ key }) => {
    if (key === 'Enter') {
      this.saveCrop();
    }
  };

  async saveCrop() {
    const { hasValidCrop, crop } = this.state;
    if (this.imageRef && hasValidCrop) {
      const croppedImgSrc = this.getCroppedImg(this.imageRef, crop);
      const { onChange } = this.props;

      if (onChange) {
        onChange(croppedImgSrc);
      }
    }
  }

  getCroppedImg = (image, crop) => {
    const canvas = document.createElement('canvas');
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext('2d');

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height,
    );

    return canvas.toDataURL('image/jpeg');
  };

  handleCropComplete = () => {
    this.setState({ hasValidCrop: true });
  };

  handleCropChange = (crop: ImageCropType) => {
    this.setState({ crop });
  };

  handleImageLoaded = image => {
    this.imageRef = image;
  };

  render() {
    const { imageSrc } = this.props;
    const { crop } = this.state;

    return (
      <CropWrap>
        <CropTitle>CROP YOUR IMAGE BY DRAGGING AND PRESS ENTER</CropTitle>
        <ReactCrop
          src={imageSrc}
          crop={crop}
          onChange={this.handleCropChange}
          onComplete={this.handleCropComplete}
          onImageLoaded={this.handleImageLoaded}
          style={{ backgroundColor: 'transparent' }}
        />
      </CropWrap>
    );
  }
}

export default ImageCrop;



// WEBPACK FOOTER //
// /opt/build/repo/src/app/components/ImageCrop/ImageCrop.js